import { WorkflowStepDefinition } from '@calm/evexia-web-sdk';
import { useUpdateWorkflowStep } from '@rhg/hooks/use-update-workflow-step';
import { logger } from '@rhg/libs/logger';
import { useMutation } from '@rhg/libs/react-query';
import { FtueStoredStepName } from '@rhg/utils/workflows';
import { storeCurrentStep } from '../../utils';

export interface SkipCachedVideoStepParams {
    stepDefnId: string;
    workflowDefnId: string;
    onStepUpdate: (step: WorkflowStepDefinition | undefined) => void;
}

// Mutation hook for skipping cached video step forward
export function useSkipCachedVideoStepForward() {
    const { updateWorkflowStepAsync } = useUpdateWorkflowStep();

    const { mutate, mutateAsync, ...otherProps } = useMutation({
        mutationFn: async (params: SkipCachedVideoStepParams) => {
            const { workflowDefnId, stepDefnId, onStepUpdate } = params;

            try {
                const response = await updateWorkflowStepAsync({
                    workflowDefnId,
                    stepDefnId,
                    request: {
                        state: 'step_skipped',
                    },
                });
                const stepObj = response.data?.stepDefn;
                const newStep = stepObj?.defnId;
                onStepUpdate(stepObj);
                if (newStep) storeCurrentStep(FtueStoredStepName, newStep);
                return response;
            } catch (error) {
                logger.error(
                    'Error updating cached workflow step forward:',
                    {
                        stepDefnId,
                        stepState: 'step_skipped',
                        workflowDefnId,
                    },
                    error
                );
                throw error;
            }
        },
    });

    return {
        skipCachedVideoStepForward: mutate,
        skipCachedVideoStepForwardAsync: mutateAsync,
        ...otherProps,
    };
}
